var _clipPath, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAltIsopropanol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "105.82mm",
    height: "122mm",
    viewBox: "0 0 105.82 122",
    xmlSpace: "preserve",
    id: "svg100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs104"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7144"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffadad",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop7142"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7130"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffadad",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop7128"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "Clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0 L161 0 L161 101 L0 101 L0 0 Z",
    transform: "translate(0, 0)",
    id: "path10494"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M0,3.8L0,3.8L0,3.8L0,3.8L0,3.8z M434,224.2 M0,3.8"
  }))), /*#__PURE__*/React.createElement("rect", {
    style: {
      mixBlendMode: "multiply",
      fill: "#ff8e8e",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#840000",
      strokeWidth: 1.464,
      strokeLinecap: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.450777
    },
    id: "rect262",
    width: 103.02634,
    height: 118.93182,
    x: 1.3825192,
    y: 1.685971,
    ry: 7.1569595
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 25.17351,88.267711 -0.392038,-0.598322 2.7298,-1.580674 c 1.501389,-0.869364 7.65239,-4.422613 13.668891,-7.8961 l 10.939098,-6.315434 0.06323,-11.081139 0.06323,-11.081145 h 0.726818 0.726819 v 11.03575 11.035746 l 12.336871,7.120164 c 6.785277,3.91609 12.96666,7.488204 13.736407,7.938031 1.29052,0.754156 1.377903,0.859487 1.121755,1.352141 -0.152779,0.293851 -0.300911,0.563098 -0.329173,0.598331 -0.0283,0.03525 -6.219783,-3.494451 -13.758934,-7.843736 C 59.032427,76.466642 52.946938,73.101781 52.748066,73.178097 52.39739,73.312669 27.051943,87.907117 26.080134,88.534065 25.617343,88.83263 25.526107,88.805824 25.173516,88.267711 Z M 50.610451,47.432714 c -1.547832,-0.506022 -2.875309,-1.693018 -3.643999,-3.258369 -0.601249,-1.224378 -0.681374,-1.659102 -0.681374,-3.696908 0,-2.039869 0.07982,-2.471902 0.683951,-3.702177 1.462813,-2.9789 4.497825,-4.230273 7.840886,-3.232895 2.575968,0.76852 4.162723,3.02047 4.407347,6.255004 0.339141,4.48422 -2.083017,7.635807 -6.053706,7.876783 -0.898086,0.05451 -1.953024,-0.04525 -2.553105,-0.241438 z m 4.726034,-2.245861 C 56.51233,44.24954 57.117188,43.013108 57.2804,41.2132 c 0.250218,-2.759484 -0.776797,-4.987523 -2.702009,-5.861795 -2.513081,-1.141236 -5.324954,0.142576 -6.111211,2.7902 -1.295154,4.36126 0.871259,8.097074 4.559939,7.863258 1.104102,-0.06997 1.584417,-0.24012 2.309366,-0.81801 z m 6.384869,-4.709416 v -7.049638 h 0.972367 0.972364 v 2.917093 2.91709 h 3.646364 3.646364 v -2.91709 -2.917093 h 0.972368 0.972362 v 7.049638 7.049641 H 71.931181 70.958813 V 44.245347 40.96362 h -3.646364 -3.646364 v 3.281727 3.281731 h -0.972364 -0.972367 z",
    id: "path2453",
    style: {
      fill: "#000000",
      strokeWidth: 0.397,
      strokeDasharray: "none",
      stroke: "#ffe854",
      strokeOpacity: 0.33333334
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light",
      fill: "#ff8e8e",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 9.73984264,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.333333,
      paintOrder: "stroke markers fill"
    },
    d: "m 96.039118,333.04651 c -0.666584,-1.06736 -0.665644,-1.36472 0.0057,-1.79185 0.442686,-0.28166 23.496972,-13.62138 51.231742,-29.64384 l 50.42686,-29.13173 0.39673,-24.34602 c 0.2182,-13.39032 0.39673,-32.12773 0.39673,-41.63871 v -17.29268 h 1.79495 1.79497 l 0.15402,41.50232 0.15403,41.50232 49.88251,28.81114 c 27.43538,15.84613 50.59345,29.35086 51.46237,30.01052 1.44413,1.09634 1.50386,1.30172 0.69539,2.39078 -0.81963,1.10411 -0.96534,1.12035 -1.98807,0.22164 -1.32367,-1.16314 -75.23778,-43.47499 -90.15734,-51.61021 -5.772,-3.14732 -11.10511,-5.91062 -11.85135,-6.14068 -1.064,-0.32802 -4.36398,1.29771 -15.29205,7.53361 -16.95062,9.67258 -76.88076,44.24871 -83.39873,48.11611 -2.583424,1.53287 -4.744853,2.78703 -4.803175,2.78703 -0.05832,0 -0.465686,-0.57589 -0.905254,-1.27975 z",
    id: "path28324",
    transform: "scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ff8e8e",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 2.15508,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.333333,
      paintOrder: "stroke markers fill"
    },
    d: "",
    id: "path28326",
    transform: "scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light",
      fill: "#ff8e8e",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 8.12976388,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.333333,
      paintOrder: "stroke markers fill"
    },
    d: "m 193.36087,178.78769 c -3.2459,-0.63628 -6.63099,-2.57161 -9.91243,-5.66715 -2.4783,-2.33791 -3.49564,-3.73784 -5.17572,-7.12221 l -2.09112,-4.21234 -0.17849,-7.01345 c -0.21307,-8.37238 0.21819,-10.87487 2.71243,-15.73958 3.01434,-5.8791 8.24546,-10.20232 14.29286,-11.81223 5.1511,-1.37131 13.35203,-0.3232 18.2255,2.32927 5.08022,2.76501 9.45834,9.25604 10.89596,16.15444 0.86056,4.12944 0.8656,11.52147 0.0103,15.14894 -1.53299,6.50176 -5.66961,12.40938 -10.70762,15.29184 -4.65552,2.66361 -12.27797,3.77818 -18.07168,2.64247 z m 13.51323,-5.47894 c 2.90866,-1.42307 6.47681,-5.0742 8.11152,-8.30015 1.5841,-3.12607 2.44953,-7.40818 2.45903,-12.16715 0.009,-4.68309 -0.58733,-7.72653 -2.21472,-11.29646 -4.0977,-8.98897 -14.61736,-12.90684 -23.49759,-8.75128 -7.33554,3.43272 -11.29877,11.5975 -10.75012,22.14671 0.35233,6.77428 2.52707,11.93703 6.56504,15.58509 3.62008,3.27052 6.87372,4.31447 12.8035,4.10806 3.34884,-0.11658 4.55407,-0.36134 6.52334,-1.32482 z",
    id: "path28328",
    transform: "scale(0.26458333)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light",
      fill: "#ff8e8e",
      fillOpacity: 0,
      fillRule: "evenodd",
      stroke: "#ffe854",
      strokeWidth: 9.64157492,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 0.333333,
      paintOrder: "stroke markers fill"
    },
    d: "M 234.41994,153.15436 V 127.4798 h 2.67909 2.67908 v 10.93959 10.9396 h 14.73497 14.73497 v -10.9396 -10.93959 h 2.67908 2.67909 v 25.67456 25.67457 h -2.67909 -2.67908 v -12.5024 -12.5024 h -14.73497 -14.73497 v 12.5024 12.5024 h -2.67908 -2.67909 z",
    id: "path28330",
    transform: "scale(0.26458333)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltIsopropanol);
export default __webpack_public_path__ + "static/media/altIsopropanol.4e38bcf3b17c19def2fac932baf16b46.svg";
export { ForwardRef as ReactComponent };